import React from "react";
import Popup from "reactjs-popup";
import "../../styles/Collapsible.scss";
import { adalApiFetch } from "../../adalConfig";
import axios from "axios";
import * as api from "../../constants/api";
import formatDate from "../../util/Date";
import { toastError } from "../../util/CommonFunctions";
import { toastSuccess } from "../../util/CommonFunctions";
import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Button, Tooltip } from "@material-ui/core";
import {
  fade,
  ThemeProvider,
  withStyles,
  makeStyles,
  createMuiTheme,
} from "@material-ui/core/styles";

import TextField from "@material-ui/core/TextField";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { green } from "@material-ui/core/colors";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#76b900",
    },
  },
});

export default class RejectReg extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      isChecked: false,
      helperText: "",
      error: false,
      textValue: "",
      isValid: false,
      rejectbtnText: "Reject",
      isRejectbtnDisabled: false,
      isRequestRejected: false,
      otherDescription: "",
      rejectionReason: "",
      rejectionReasons: []
    };
    this.openModal = this.openModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.setRejectStatus = this.setRejectStatus.bind(this);
    this.onChangeText = this.onChangeText.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.rejectbtnClick = this.rejectbtnClick.bind(this);
  }

  openModal() {
    this.setState({ open: true });

    adalApiFetch(axios, api.GET_REJECTION_REASONS, {
      method: "get",
    })
      .then((response) => {
        this.setState({
          rejectionReasons: response.data
        });
      });
  }

  closeModal() {
    this.setState({
      open: false,
      rejectionReason: "",
      otherDescription: "",
      helperText: "",
      error: false,
      isValid: false,
    });
  }
  rejectbtnClick() {
    this.setState({
      open: false,
      rejectionReason: "",
      otherDescription: "",
      helperText: "",
      error: false,
      isValid: false,
    });
  }
  handleChange(event) {
    this.setState({ isChecked: event.target.checked });
  }
  onChangeText(event) {
    if (event.target.value.length > 0) {
      this.setState({
        textValue: event.target.value,
        helperText: "",
        error: false,
        isValid: true,
      });
    } else {
      this.setState({ textValue: "", isValid: false });
    }
  }
  handleReasonChange = (event) => {
    const value = event.target.value;

    this.setState({
      rejectionReason: value,
      error: false,
      helperText: "",
      isValid:
        value !== "" &&
        (value !== 4 || this.state.otherDescription.trim() !== "")
    })
  }
  handleDescriptionChange = (event) => {
    const notes = event.target.value;
    console.log(notes)
    this.setState({
      otherDescription: notes,
      error: false,
      helperText: "",
      isValid:
        this.isOtherReason()
          ? notes.trim().length > 0
          : this.state.rejectionReason !== "",
    });
  };
  isOtherReason() {
    const selectedReason =
      this.state &&
        this.state.rejectionReasons &&
        Array.isArray(this.state.rejectionReasons)
        ? this.state.rejectionReasons.find(
          x => x && x.id === this.state.rejectionReason
        )
        : null;
    return (
      selectedReason &&
      selectedReason.description &&
      selectedReason.description.toLowerCase() === "other"
    );
  }
  setRejectStatus() {
    if (this.state.textValue) {
      this.setState({ helperText: "", error: false, isValid: true });
    } else {
      this.setState({
        helperText: "Should not be Empty",
        error: true,
        isValid: false,
      });
    }
    let data = {};

    data = {
      RegID: this.props.regID,
      RejectionReason: this.state.rejectionReason,
      Description: this.isOtherReason()
        ? this.state.otherDescription
        : ""
    };

    if (this.state.isValid) {
      adalApiFetch(axios, api.POST_REJECT_REGISTRATION, {
        method: "post",
        data: data,
      })
        .then((response) => {
          console.log(response);
          this.setState({
            rejectbtnText: "Registration rejected",
            isRejectbtnDisabled: true,
            isRequestRejected: true,
          });
          toastSuccess("Registration has been rejected successfully.");
          // Notify parent component with the rejection reason
          if (this.props.onrejectionSaved) {
            this.props.onrejectionSaved(this.state.otherDescription);
          }

          this.closeModal();
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            toastError(error);
          }
        });
    }
  }
  render() {
    const isRejected =
      this.props.statusName === "rejected" || this.state.isRequestRejected;
    if (isRejected) {
      return <RegistrationRejected></RegistrationRejected>;
    }

    return (
      <div className="auditTrailSty">
        <Button
          variant="contained"
          onClick={this.openModal}
          size="small"
          style={{ marginLeft: "1em" }}
          className={"auditBtn cancelRedStyles"}
        >
          Reject Registration
        </Button>
        <Popup className="rejectPopup"
          open={this.state.open}
          closeOnDocumentClick
          onClose={this.closeModal}
        >
          <div style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "300px"
          }}
            className="modal" >
            <a className="close" onClick={this.closeModal}>
              &times;
            </a>
            <div style={{ flex: 1 }}>
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                spacing={3}
              >
                <Grid item xs={11}>
                  <ThemeProvider theme={theme}>
                    <FormControl variant="outlined" fullWidth>
                      <InputLabel>Reason for Rejection</InputLabel>
                      <Select
                        value={this.state.rejectionReason || ""}
                        onChange={this.handleReasonChange}
                        label="Reason for Rejection"
                        MenuProps={{
                          disablePortal: true,
                          PaperProps: {
                            style: {
                              zIndex: 9999,
                            },
                          },
                        }}
                      >
                        <MenuItem value="">
                          <em>Select a reason</em>
                        </MenuItem>
                        {this.state.rejectionReasons &&
                          this.state.rejectionReasons.map(reason => (
                            <MenuItem key={reason.id} value={reason.id}>
                              {reason.description}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                    {
                      this.isOtherReason() &&
                      (
                        <TextField
                          fullWidth
                          multiline
                          rows={3}
                          variant="outlined"
                          label="Description"
                          value={this.state.otherDescription}
                          onChange={this.handleDescriptionChange}
                          InputProps={{
                            style: {
                              height: "auto",
                              minHeight: "100px",
                              alignItems: "flex-start",
                              marginTop: "18px"
                            },
                          }}
                        />
                      )}
                  </ThemeProvider>
                </Grid>
              </Grid>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px"
              }}
            >
              <Grid item xs={12}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "12px"
                  }}
                >
                  <Tooltip
                    title={
                      !this.state.isValid
                        ? "Please select a rejection reason."
                        : ""
                    }
                    arrow
                  >
                    <span style={{ display: "inline-block" }}>
                      <Button
                        variant="contained"
                        onClick={this.setRejectStatus}
                        disabled={!this.state.isValid}
                        style={{
                          backgroundColor: this.state.isValid
                            ? "#76b900"
                            : "#cccccc",
                          color: "white",
                          minWidth: "64px",
                          height: "36px",
                          padding: "6px 16px",
                          fontSize: "0.875rem",
                          fontWeight: 500,
                          lineHeight: 1.75,
                          textTransform: "uppercase",
                          boxShadow:
                            "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
                        }}
                      >
                        Save
                      </Button>
                    </span>
                  </Tooltip>

                  <Button
                    variant="contained"
                    onClick={this.rejectbtnClick}
                    style={{
                      minWidth: "64px",
                      height: "36px",
                      padding: "6px 16px",
                      fontSize: "0.875rem",
                      fontWeight: 500,
                      lineHeight: 1.75,
                      textTransform: "uppercase",
                      marginLeft: "0",
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </Grid>
            </div>
          </div >
        </Popup >
      </div >
    );
  }
}

function RegistrationRejected(props) {
  return (
    <div>
      <Button
        variant="contained"
        size="small"
        style={{
          marginLeft: "1em",
          backgroundColor: "#ff9800",
          color: "white",
          opacity: 1,
          minWidth: "64px",
          height: "36px",
          padding: "6px 16px",
          fontSize: "0.875rem",
          fontWeight: 500,
          lineHeight: 1.75,
          textTransform: "uppercase"
        }} className={"auditBtn"}
      >
        Registration Rejected
      </Button>
    </div>
  );
}